import React from 'react';
import ReactDOM from 'react-dom';

import alertStyles from './alertTemplate.scss';

/**
 * Blocks the test behind the restore cards. Portalled to body: the card's transform would
 * otherwise confine a fixed child to the card. mousedown is cancelled so focus stays in the card.
 */
const keepFocusInCard = (event) => {
    event.preventDefault();
};

const EssayRestoreScrim = () => ReactDOM.createPortal(
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    <div className={alertStyles.essayRestoreScrim} aria-hidden="true" onMouseDown={keepFocusInCard} />,
    document.body
);

export default EssayRestoreScrim;
